import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { ReactComponent as AllTools } from "../Icons/AllTools.svg";
import { ReactComponent as CaretDownIcon } from "../Icons/caret-down.svg";
import { ReactComponent as SlideIn } from "../Icons/Slide_in.svg";
import { ReactComponent as DataFormatIcon } from "../Icons/menu.svg";
import { ReactComponent as BracketsIcon } from "../Icons/bracketsRaw.svg";
import { ReactComponent as BinaryIcon } from "../Icons/binaryRaw.svg";
import { ReactComponent as LockIcon } from "../Icons/lockRaw.svg";
import { ReactComponent as TextIcon } from "../Icons/textRaw.svg";
import { ReactComponent as DiffIcon } from "../Icons/DiffRaw.svg";
import { ReactComponent as DatabaseIcon } from "../Icons/databaseRaw.svg";
import { ReactComponent as ClockIcon } from "../Icons/clockRaw.svg";
import { ReactComponent as ImageIcon } from "../Icons/imageRaw.svg";
import { FileText, PenTool, Sparkles } from "lucide-react";
import { Nav } from "react-bootstrap";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Tools } from "../Services/Tools";
import { getCategoryRoute, getToolRoute, getToolDisplayName } from "../HomePage/toolRoutes";
import { renderToolIcon } from "../Shared/toolIcons";

const Link = React.forwardRef(({ to, ...props }, ref) => (
  <RouterLink ref={ref} to={"/app/tools" + (to === "/" ? "" : to)} {...props} />
));

const categoryIcons = {
  "JSON Tools": BracketsIcon,
  "Data Format / Markup Tools": DataFormatIcon,
  "API & Diagram Tools": PenTool,
  "Encoder / Decoder": BinaryIcon,
  "Text Utilities": TextIcon,
  "Identifier / Value Generators": Sparkles,
  "Diff Tools": DiffIcon,
  "Crypto & Security": LockIcon,
  "Database Tools": DatabaseIcon,
  "Time & Date": ClockIcon,
  "Image Tools": ImageIcon,
  "Document Tools": FileText,
};

function toSidebarPath(route) {
  if (!route || route === "/") return "/";
  return route.startsWith("/") ? route : `/${route}`;
}

function renderCategoryIcon(categoryName) {
  const Icon = categoryIcons[categoryName] || DataFormatIcon;
  return <Icon className="CategoryIcon" />;
}

function Dashboard({ collapsed, toggleSidebar }) {
  const { pathname } = useLocation();
  const toolPath = decodeURI(pathname).replace(/^\/app\/tools\/?/, "");
  const activeCategory = Tools.find(category => getCategoryRoute(category.CategoryName) === toolPath ||
    category.SubCategory.some(tool => getToolRoute(tool.SubCategory) === toolPath));
  const [openCategory, setOpenCategory] = useState(activeCategory?.CategoryName || null);

  useEffect(() => {
    setOpenCategory(activeCategory?.CategoryName || null);
  }, [activeCategory]);

  const toggleCategory = (name) => {
    setOpenCategory((prev) => (prev === name ? null : name));
  };

  if (collapsed) {
    return (
      <div className="DashboardCollapsed" onClick={toggleSidebar}>
        <SlideIn className="slideicon" />
      </div>
    );
  }

  return (
    <Nav className="Dashboard">
      <div className="Slider" onClick={toggleSidebar}>
        <SlideIn className="slideicon" />
      </div>

      <Nav.Link
        as={Link}
        to="/"
        className="NoUnderline"
        onClick={() => {
          setOpenCategory(null);
        }}
      >
        <div className="ToolCategory">
          <div className="Tools">
            <AllTools className="DashboardIcon" />
            <span className="CategoryName">All Tools</span>
          </div>
        </div>
      </Nav.Link>

      {Tools.map((category) => {
        const isOpen = openCategory === category.CategoryName;

        return (
          <div key={category.CategoryName}>
            <div
              className={`ToolCategory ${isOpen ? "active-category" : ""}`}
              onClick={() => toggleCategory(category.CategoryName)}
            >
              <div className="Tools">
                {renderCategoryIcon(category.CategoryName)}
                <span className="CategoryName">{category.CategoryName}</span>
              </div>
              <CaretDownIcon
                className="Caretdown"
                style={{ transform: isOpen ? "rotate(180deg)" : "none" }}
              />
            </div>

            {isOpen && (
              <div className="ToolList">
                {category.SubCategory.map((tool) => {
                  const route = getToolRoute(tool.SubCategory);
                  const sidebarPath = toSidebarPath(route);

                  return (
                    <Nav.Link
                      key={tool.SubCategory}
                      as={Link}
                      to={sidebarPath}
                      state={{
                        categoryName: category.CategoryName,
                        toolName: tool.SubCategory,
                      }}
                      className={toolPath === route ? "active" : ""}
                      aria-current={toolPath === route ? "page" : undefined}
                    >
                      {renderToolIcon(tool.SubCategory)}
                      <span className="CatogoryName">{getToolDisplayName(tool.SubCategory)}</span>
                    </Nav.Link>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </Nav>
  );
}

export default Dashboard;
